import { jsx as i } from "react/jsx-runtime";
import '../../assets/Divider.css';const d = "_divider_1rceb_1", r = {
  divider: d
}, s = () => /* @__PURE__ */ i("div", { className: `${r.divider} iOSPWA-divider` });
export {
  s as Divider
};
